(ns frontend.ui.component.percentage-layout.view
  (:require
   [frontend.ui.component.percentage-layout.style :as style]
   [herb.core :refer [<class]]))

;; e.g. [percentage-layout/view nil [50 25 25] [:div "first"] [:div "second"] [:div "third"]]
;;  means the first element will take 50% of width, rest two 25% each
(defn view
  [{:keys [] :as opts} percentages & children]
  (into [:div
         {:class (<class style/row opts)}]
        (for [[percentage child] (map vector percentages children)]
          [:div
           {:class (<class style/child percentage)}
           child])))
